import styled from 'styled-components';
import { space } from 'styled-system';

export const Box = styled('div')(props => (`
    padding: ${props.theme.space.sm};
    background-color: ${props.theme.colors[props.backgroundColor || 'background']};
`), space);
